export default __webpack_public_path__ + "static/media/bank.19cb3a56.png";